import { Spin } from 'antd';
import React from 'react'

export default function PrevViewer({base64Image, loader}) {
  return (
    <div>
      {loader?
      <Spin/>
      :<img
        src={`${base64Image}`}
        alt="Failed to load"
        style={{ maxWidth: "100%", height: "auto" }}
      />}
    </div>
  );
}
